export default {
    data() {
        return {
            loading: false,
            list: [],
            page: this.$help.getPage(),
            params: {},
            sortParam: [],
            fieldFilters: {
                conditionRelation: 'and',
                childField: [],
            },

            leadingDialog: {
                show: false,
                loading: false,
            },
        }
    },
    created() {
        setTimeout(() => {
            this.init();
        }, 0)
    },
    methods: {
        init() {
            this.page.current = 1;
            this.getList();
        },
        getQueryParam() {
            let model = this.$help.deepClone(this.params)

            if (this.query) {
                model = this.$help.joinObj(model, this.query)
            }

            if (this.queryFunc) {
                model = this.$help.joinObj(model, this.queryFunc())
            }

            const page = this.$help.deepClone(this.page)
            page.orders = this.sortParam.length > 0 ? this.sortParam : undefined

            this.fieldFilters.childField.length > 0 && (model.fieldFilters = this.fieldFilters)
            return {
                page: page,
                model,
            }
        },
        getList() {
            this.loading = true;
            this.$api.post(this.api.list, this.getQueryParam())
                .then(res => {
                    this.list = res.records;
                    this.page.total = res.total;
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        pageChange(params) {
            console.log(params)
            params.size && (this.page.size = params.size)
            params.current && (this.page.current = params.current)
            this.getList();
        },
        paramChange(params) {
            this.params = params;
            this.init();
        },
        sort(param) {
            if (param.order) {
                this.sortParam = [{
                    column: param.prop,
                    asc: param.order === 'ascending'
                }];
            } else {
                this.sortParam = []
            }
            this.getList();
        },
        cndClusterChange(cnds) {
            this.fieldFilters.childField = cnds;
            this.init();
        },


        leadingIn() {
            this.leadingDialog.show = true
        },
        leadingSave() {
            this.init()
            this.leadingDialog.show = false
        },
        leadingOut() {
            this.$store.commit('confirm', {
                content: '确定导出吗',
                callback:(next, back) => {
                    const param = this.getQueryParam()
                    param.exportKey = new Date().getTime()
                    this.$api.post(this.api.leadingOut, param)
                        .then(res => {
                            next();
                            window.open(`/sys/file/fileExportDownload?fileName=${res.fileName}`)
                            this.$help.success("导出成功");
                        })
                        .finally(back)
                },
            })
        },
    },
}